import { render, staticRenderFns } from "./ProductListAttribute.vue?vue&type=template&id=01d8c1fa&scoped=true&"
import script from "./ProductListAttribute.vue?vue&type=script&lang=js&"
export * from "./ProductListAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8c1fa",
  null
  
)

export default component.exports